import { useEffect } from 'react';

export function useHeaderDesktopHeightCssVariable() {
  /**
   * Временное решение определения высоты шапки через js, т.к. в новом эксперименте шапка поменяла дизайн и высоту.
   * Переменная нужна для корректной верстки.
   *
   * TODO В CD-192282 хотим доставать CSS переменную с высотой напрямую из шапки, когда она появится этот код можно будет удалить.
   */
  /* istanbul ignore next */
  useEffect(() => {
    if (typeof document === 'undefined') {
      return;
    }
    const headerHeight = document.querySelector('#header-frontend')?.clientHeight;
    if (headerHeight) {
      document.body.style.setProperty('--header-frontend-desktop-height', headerHeight.toString() + 'px');
    }
  }, []);
}
